export default __webpack_public_path__ + "media/images/map-image-d275d4c04c9fb4c6850b2e86fc2d01a6.jpg";